"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "subtitle1ClassNames", {
    enumerable: true,
    get: function() {
        return _useSubtitle1Stylesstyles.subtitle1ClassNames;
    }
});
const _export_star = require("@swc/helpers/_/_export_star");
_export_star._(require("./Subtitle1"), exports);
const _useSubtitle1Stylesstyles = require("./useSubtitle1Styles.styles");
